var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 36.25C28.975 36.25 36.25 28.975 36.25 20C36.25 11.025 28.975 3.75 20 3.75C11.025 3.75 3.75 11.025 3.75 20C3.75 28.975 11.025 36.25 20 36.25ZM20.8833 12.8667C20.649 12.6326 20.3313 12.5011 20 12.5011C19.6688 12.5011 19.351 12.6326 19.1167 12.8667L14.1167 17.8667C13.9939 17.9811 13.8954 18.1191 13.827 18.2724C13.7587 18.4258 13.722 18.5913 13.719 18.7591C13.7161 18.927 13.7469 19.0937 13.8098 19.2493C13.8727 19.405 13.9662 19.5464 14.0849 19.6651C14.2036 19.7838 14.345 19.8773 14.5007 19.9402C14.6563 20.0031 14.823 20.0339 14.9909 20.031C15.1587 20.028 15.3242 19.9913 15.4776 19.923C15.6309 19.8546 15.7689 19.7561 15.8833 19.6333L18.75 16.7667L18.75 26.25C18.75 26.5815 18.8817 26.8995 19.1161 27.1339C19.3505 27.3683 19.6685 27.5 20 27.5C20.3315 27.5 20.6495 27.3683 20.8839 27.1339C21.1183 26.8995 21.25 26.5815 21.25 26.25L21.25 16.7667L24.1167 19.6333C24.3536 19.8541 24.667 19.9743 24.9909 19.9686C25.3147 19.9629 25.6237 19.8317 25.8527 19.6027C26.0817 19.3737 26.2129 19.0647 26.2186 18.7409C26.2243 18.417 26.1041 18.1036 25.8833 17.8667L20.8833 12.8667Z",
    fill: "#FF782C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.c0c857cf52b34ab317818f90e6e18ff2.svg";
export { ForwardRef as ReactComponent };